<script lang="ts">
import { I3pEventsEnum } from '@nuxtDatakodeUtils/types/I3pEvents.enum'
import MapPanelIntention from '~/components/I3pComponent/intentions/MapPanel.vue'
import IntentionListPanel from '~/components/I3pComponent/intentions/ListPanel.vue'
import IntentionTopButtons from '~/components/I3pComponent/intentions/TopButtons.vue'
import IntentionEntityPanel from '~/components/I3pComponent/intentions/EntityPanel.vue'
import { IntentionI3pService } from '~/services/intentions.i3p.service'
import NavigationModeSwitcher from '~/components/I3pComponent/common/map/NavigationModeSwitcher.vue'

export default {
    name: 'IntentionsI3p',
    components: {
        IntentionEntityPanel,
        IntentionTopButtons,
        IntentionListPanel,
        MapPanelIntention,
        NavigationModeSwitcher,
    },
    props: {
        i3pService: { type: IntentionI3pService, required: true },
        baseUrl: { type: String, required: true },
    },
    data() {
        return {
            navigationModeInitialValue: 'zoomOnItem',
        }
    },
    async mounted() {
        this.i3pService.emitter
            .on(I3pEventsEnum.entityNotFound, (event: { currentEntityK: string }) => {
                this.$showToaster({ title: `Intention ${event.currentEntityK} non trouvée !`, text: '', color: 'danger', icon: 'mdi-alert' })
            })
    },
    methods: {
        changeNavigationMode(navigationMode: NavigationMode): void {
            this.i3pService.setNavigationMode(navigationMode)
            this.navigationModeInitialValue = navigationMode
            if (navigationMode === 'zoomOnItem') {
                this.$refs.mapPanel?.zoomOnCurrentItem()
            }
            if (navigationMode === 'displayAll') {
                this.$refs.mapPanel?.displayAll()
            }
        },
    },
}
</script>

<template>
    <I3p :i3p-service>
        <template #topButtons>
            <div class="w-100 d-flex pb-2 justify-space-between align-center">
                <IntentionTopButtons :base-url="baseUrl" />
                <NavigationModeSwitcher :initial-value="navigationModeInitialValue" @change-mode="changeNavigationMode($event)" />
            </div>
        </template>
        <template #map-panel>
            <MapPanelIntention ref="mapPanel" />
        </template>
        <template #list-panel>
            <IntentionListPanel :base-url="baseUrl" />
        </template>
        <template #entity-panel>
            <IntentionEntityPanel :base-url="baseUrl" />
        </template>
        <template #bottomButtons>
            <I3pPanelsEditButtonsBottom />
        </template>
    </I3p>
</template>
